import React from 'react';
import { Link } from 'react-router-dom';
import { PageHero } from '../components/PageHero';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { PackageIcon, InfoIcon, ChevronRightIcon } from 'lucide-react';
export function RentalsPage() {
  useScrollReveal();
  const categories = [{
    title: 'Stage Structures',
    items: ['Aluminum Stage Platforms', 'Scaffolding Stages', 'Beauty Pageant / Parade Ramps', 'Custom Stage Configurations', 'Stage Skirting & Steps']
  }, {
    title: 'Roofing & Shading',
    items: ['Stage Roofing Systems', 'Truss Roof Structures', 'Outdoor Event Shading', 'Weather Protection Covers']
  }, {
    title: 'Sound Equipment',
    items: ['Line Array Systems', 'Point Source Speakers', 'Digital Mixing Consoles', 'Wireless Microphone Systems', 'Stage Monitors', 'DJ Equipment']
  }, {
    title: 'Lighting Equipment',
    items: ['Moving Heads (Spot/Wash/Beam)', 'LED Par Cans', 'Follow Spots', 'Lighting Consoles', 'Atmospheric Effects (Smoke/Haze)', 'Trussing & Rigging']
  }, {
    title: 'Visual Equipment',
    items: ['LED Video Walls', 'High-Lumen Projectors', 'Fast-Fold Screens', 'Seamless Switchers', 'Preview Monitors', 'Camera Equipment']
  }, {
    title: 'Special Event Setups',
    items: ['Pipe & Drape Systems', 'Crowd Control Barriers', 'Truss Totems', 'Lecterns / Podiums', 'Power Distribution']
  }];
  return <main className="w-full" data-id="element-435">
      <PageHero title="Equipment & Structure Rentals" subtitle="Premium, industry-standard equipment available for dry hire or full-service production." icon={PackageIcon} data-id="element-436" />

      <section className="py-20 px-6 bg-brand-black" data-id="element-437">
        <div className="max-w-7xl mx-auto" data-id="element-438">
          {/* Pricing Note */}
          <div className="glass-card p-6 md:p-8 mb-16 flex flex-col md:flex-row items-center gap-6 border-brand-blue/30 reveal" data-id="element-439">
            <div className="w-12 h-12 rounded-full bg-brand-blue/20 flex items-center justify-center shrink-0" data-id="element-440">
              <InfoIcon className="w-6 h-6 text-brand-blue" data-id="element-441" />
            </div>
            <div data-id="element-442">
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-443">
                Tailored Pricing
              </h3>
              <p className="text-brand-muted-light" data-id="element-444">
                Pricing varies depending on event size, duration, location, and
                technical requirements. Contact us for a tailored quote that
                matches your specific needs.
              </p>
            </div>
            <div className="md:ml-auto shrink-0 w-full md:w-auto" data-id="element-445">
              <Link to="/contact" className="btn-glow w-full md:w-auto" data-id="element-446">
                Request Rental Quote
              </Link>
            </div>
          </div>

          {/* Catalog Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-447">
            {categories.map((category, index) => <div key={index} className="glass-card p-8 reveal" style={{
            transitionDelay: `${index * 100}ms`
          }} data-id="element-448">
                <h3 className="text-xl font-bold text-white mb-6 pb-4 border-b border-white/10" data-id="element-449">
                  {category.title}
                </h3>
                <ul className="space-y-4" data-id="element-450">
                  {category.items.map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-muted-light group" data-id="element-451">
                      <ChevronRightIcon className="w-5 h-5 text-brand-blue shrink-0 group-hover:translate-x-1 transition-transform" data-id="element-452" />
                      <span data-id="element-453">{item}</span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>

      <section className="py-20 px-6 bg-brand-charcoal text-center reveal" data-id="element-454">
        <div className="max-w-3xl mx-auto" data-id="element-455">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-456">
            Not sure what you need?
          </h2>
          <p className="text-brand-muted-light mb-8 text-lg" data-id="element-457">
            Our technical experts can advise on the best equipment for your
            specific venue and audience size.
          </p>
          <Link to="/contact" className="btn-outline" data-id="element-458">
            Speak to a Technician
          </Link>
        </div>
      </section>
    </main>;
}